module.exports = __webpack_public_path__ + "static/hero-image-12c12f5b86e414b83c9e4e9f0793de85.jpg";